import React, { useState, useEffect, useRef } from 'react';
import {
    TabContent, TabPane, Nav, NavItem, NavLink, Card, Button, CardTitle, CardText, Row, Col,
    InputGroupText, Input, InputGroup, InputGroupAddon, FormGroup
} from 'reactstrap';
import DivisionCardSmall from '../Division/DivisionCardSmall';
import { sendAccountInvoice, sendInvoices, sendTestAccountInvoice, getDivisions, getFees } from '../../API';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircle, faSquare } from '@fortawesome/free-regular-svg-icons'
import { faCheckCircle, faCheckSquare, faUsers } from '@fortawesome/free-solid-svg-icons'
import LoadingSVG from '../../icons/Spinner-1s-200px.svg';
import AccountCard from '../Account/AccountCard';
import AccountSelect from '../Account/AccountSelect';
import LetterConfirmationModal from './LetterConfirmationModal';
import LettersSuccessModal from './LettersSuccessModal';
import Docxtemplater from 'docxtemplater';
import PizZip from 'pizzip';
import PizZipUtils from 'pizzip/utils/index.js';
import { saveAs } from 'file-saver'
import { getShortDate, getCurrency, sleep } from '../../Helper';

function AccountLetters(props) {
    const [isSendingEmails, setIsSendingEmails] = useState(false);
    const [accountSelectModal, setAccountSelectModal] = useState(false);
    const [selectedAccounts, setSelectedAccounts] = useState([]);
    const [divisions, setDivisions] = useState([]);
    const [isLoadingDivisions, setIsLoadingDivisions] = useState(false);
    const [divisionId, setDivisionId] = useState(0);
    const templateFileEl = useRef(null);
    const [templateFile, setTemplateFile] = useState(null);
    const [letterConfirmationModal, setLetterConfirmationModal] = useState(false);
    const [lettersSuccessModal, setLettersSuccessModal] = useState(false);

    useEffect(() => {
        fetchDivisions();
    }, []);

    useEffect(() => {
        if (props.selectedAccounts.length > 0) {
            setSelectedAccounts(props.selectedAccounts);
        }
    }, [props.selectedAccounts]);

    const fetchDivisions = async () => {
        try {
            setIsLoadingDivisions(true);
            const divisionsResult = await getDivisions();
            setDivisions(divisionsResult);
        } catch (ex) {
            console.log(ex);
        } finally {
            setIsLoadingDivisions(false);
        }
    };

    //const sendEmails = async () => {
    //    setIsSendingEmails(true);

    //    let selectedDivisions = [divisionId]
    //    if (divisionId == 0) {
    //        selectedDivisions = [1, 2, 3]
    //    }

    //    let fees = [];
    //    const accountIDs = selectedAccounts.map(a => a.accountID);
    //    while (accountIDs.length > 0) {
    //        fees = [...fees, ...await getFees({
    //            accountIDs: accountIDs.splice(0, 20),
    //            divisionIDs: selectedDivisions,
    //            paid: 0,
    //            takeAmount: 100
    //        })];
    //    }
    //    const promises = [];

    //    const formData = new FormData();

    //    // Update the formData object
    //    for (let d of selectedDivisions) {
    //        formData.append(
    //            "DivisionIDs",
    //            d
    //        );
    //    }

    //    for (let account of selectedAccounts) {
    //        try {
    //            account.fees = fees.filter(f => f.accountID === account.accountID);
    //            if (account.fees === null || account.fees.length === 0)
    //                continue;

    //            account.totalDue = getCurrency(account.fees.map(f => f.currentBalance).reduce((a, b) => a + b, 0));
    //            account.link = window.env.app.baseUrl + '?linkAccountId=' + account.accountID;

    //            for (let fee of account.fees) {
    //                fee.dueDate = getShortDate(fee.dueDate);
    //                fee.currentBalance = getCurrency(fee.currentBalance);
    //            }

    //            const generatedDoc = await generateDocument(account);

    //            formData.set(
    //                "InvoiceFile",
    //                generatedDoc,
    //                account.accountNumber
    //            );

    //            promises.push(sendAccountInvoice(account.accountID, formData));
    //            await sleep(500); //This feels really wrong, but we can't send so many requests at one time. There's probably a better way around it.
    //        } catch (ex) {
    //            console.log(ex);
    //        }
    //    }
    //    try {
    //        console.log("Awaiting promises");
    //        await Promise.allSettled(promises);
    //        toggleLettersSuccessModal();
    //    } catch (ex) {
    //        console.log(ex);
    //    } finally {
    //        setIsSendingEmails(false);
    //    }
    //};

    const sendEmails = async () => {
        const startTime = new Date();
        console.log(startTime);
        try {
            setIsSendingEmails(true);

            let selectedDivisionIDs = [divisionId]
            if (divisionId == 0) {
                selectedDivisionIDs = [1, 2, 3]
            }
            let accounts = [...selectedAccounts];
            let fees = [];
            const accountIDs = selectedAccounts.map(a => a.accountID);
            while (accountIDs.length > 0) {
                fees = [...fees, ...await getFees({
                    accountIDs: accountIDs.splice(0, 20),
                    divisionIDs: selectedDivisionIDs,
                    paid: 0,
                    takeAmount: 0
                })];
            }

            const formData = new FormData();

            for (let d of selectedDivisionIDs) {
                formData.append(
                    "DivisionIDs",
                    d
                );
            }

            for (let account of accounts) {
                account.fees = fees.filter(f => f.accountID === account.accountID);
                if (account.fees === null || account.fees.length === 0)
                    throw 'No fees to send.';

                account.totalDue = getCurrency(account.fees.map(f => f.currentBalance).reduce((a, b) => a + b, 0));
                account.link = window.env.app.baseUrl + '?linkAccountId=' + account.accountID;

                for (let fee of account.fees) {
                    fee.dueDate = getShortDate(fee.dueDate);
                    fee.currentBalance = getCurrency(fee.currentBalance);
                }

                const generatedDoc = await generateDocument(account);
                account.generatedDoc = generatedDoc;
            }

            console.log(accounts.length);

            let attempts = 0;
            while (accounts.length > 0 && attempts < 5) {
                attempts++;
                const promises = [];
                for (let account of accounts) {
                    try {
                        // Update the formData object
                        formData.set(
                            "InvoiceFile",
                            account.generatedDoc,
                            account.accountNumber
                        );

                        promises.push(sendAccountInvoice(account.accountID, formData));
                        //await sleep(500); //This feels really wrong, but we can't send so many requests at one time. There's probably a better way around it.
                        //Hanlded by resending failed requests. Not waiting at all. Perhaps there's a certain amount of time before trying to resend...
                    } catch (ex) {
                        console.log(ex);
                    }
                }
                console.log("Awaiting promises");
                const results = await Promise.allSettled(promises);
                const rejectedIDs = [];
                for (let i = 0; i < results.length; i++) {
                    if (results[i].status !== 'fulfilled') {
                        rejectedIDs.push(accounts[i].accountID);
                    }
                }
                accounts = accounts.filter(a => rejectedIDs.includes(a.accountID));
            }

            if (accounts.length === 0) {
                toggleLettersSuccessModal();
            } else {
                //accounts should only have those that failed to send 5 times.
                console.log(accounts);
            }
            const endTime = new Date();
            console.log("Start: ", startTime);
            console.log("End: ", endTime);
            console.log("Diff: ", endTime - startTime);
        } catch (ex) {
            console.log(ex);
        } finally {
            setIsSendingEmails(false);
        }
    };

    const sendTestEmail = async () => {
        try {
            setIsSendingEmails(true);

            if (selectedAccounts.length > 0) {
                const account = selectedAccounts[0];
                let selectedDivisions = [divisionId]
                if (divisionId == 0) {
                    selectedDivisions = [1, 2, 3]
                }

                account.fees =  await getFees({
                    accountIDs: account.accountID,
                    divisionIDs: selectedDivisions,
                    paid: 0
                });
                if (account.fees === null || account.fees.length === 0)
                    throw 'No fees to send.';

                account.totalDue = getCurrency(account.fees.map(f => f.currentBalance).reduce((a, b) => a + b, 0));
                account.link = window.env.app.baseUrl + '?linkAccountId=' + account.accountID;

                for (let fee of account.fees) {
                    fee.dueDate = getShortDate(fee.dueDate);
                    fee.currentBalance = getCurrency(fee.currentBalance);
                }

                const generatedDoc = await generateDocument(account);

                const formData = new FormData();

                // Update the formData object
                for (let d of selectedDivisions) {
                    formData.append(
                        "DivisionIDs",
                        d
                    );
                };

                formData.append(
                    "InvoiceFile",
                    generatedDoc,
                    account.accountNumber
                );

                const result = await sendTestAccountInvoice(account.accountID, formData);
                console.log(result);
                toggleLettersSuccessModal();
            }
        } catch (ex) {
            console.log(ex);
        } finally {
            setIsSendingEmails(false);
        }
    };

    const generateDocument = async (account) => {
        return new Promise(async (resolve, reject) => {
            if (templateFile !== null) {

                var reader = new FileReader();
                reader.readAsBinaryString(templateFile);

                reader.onerror = function (evt) {
                    console.log("error reading file", evt);
                    alert("error reading file" + evt)
                }
                reader.onload = function (evt) {
                    const content = evt.target.result;
                    var zip = new PizZip(content);

                    var doc = new Docxtemplater(zip, { linebreaks: true });
                    doc.setData(account);
                    try {
                        // render the document (replace all occurences of {first_name} by John, {last_name} by Doe, ...)
                        doc.render();
                    } catch (error) {
                        // The error thrown here contains additional information when logged with JSON.stringify (it contains a properties object containing all suberrors).
                        function replaceErrors(key, value) {
                            if (value instanceof Error) {
                                return Object.getOwnPropertyNames(value).reduce(function (
                                    error,
                                    key
                                ) {
                                    error[key] = value[key];
                                    return error;
                                },
                                    {});
                            }
                            return value;
                        }
                        console.log(JSON.stringify({ error: error }, replaceErrors));

                        if (error.properties && error.properties.errors instanceof Array) {
                            const errorMessages = error.properties.errors
                                .map(function (error) {
                                    return error.properties.explanation;
                                })
                                .join("\n");
                            console.log("errorMessages", errorMessages);
                            // errorMessages is a humanly readable message looking like this :
                            // 'The tag beginning with "foobar" is unopened'
                        }
                        //throw error;
                        reject(error);
                    }
                    var out = doc.getZip().generate({
                        type: "blob",
                        mimeType:
                            "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    }); //Output the document using Data-URI
                    //saveAs(out, "output.docx");
                    resolve(out);
                }
            }
        });
    };

    const updateFile = (e) => {
        if (e.target && e.target.files.length > 0)
            setTemplateFile(e.target.files[0]);
        else
            setTemplateFile(null);
    };

    const acceptLetterConfirmationModal = () => {
        sendEmails();
        setLetterConfirmationModal(false);
    };

    const declineLetterConfirmationModal = () => {
        setLetterConfirmationModal(false);
    };

    const toggleLetterConfirmationModal = () => setLetterConfirmationModal(!letterConfirmationModal);

    const toggleAccountSelectModal = () => setAccountSelectModal(!accountSelectModal);

    const selectAccounts = (accounts) => {
        if (accounts !== null) {
            setSelectedAccounts(accounts);
        }
    };

    const cancelAccount = (accountId) => {
        setSelectedAccounts(selectedAccounts.filter(so => so.accountID !== accountId));
    };

    const accountCardOptions = {
        fields: {
            active: true,
            accountNumber: true,
            account: true,
            contact: false,
            address: false,
            email: false,
            balance: true
        },
        actions: {
            view: false,
            eidt: false,
            makePayment: false,
            generateLetter: false,
            delete: false,
            select: false,
            cancel: true
        }
    };

    const accountSelectOptions = {
        fields: {
            active: true,
            accountNumber: true,
            account: true,
            contact: false,
            address: false,
            email: false,
            balance: true
        },
        actions: {
            view: false,
            eidt: false,
            makePayment: false,
            generateLetter: false,
            delete: false,
            select: true,
            cancel: false
        }
    };

    const toggleLettersSuccessModal = () => setLettersSuccessModal(!lettersSuccessModal);

    const selectedAccountsJSX = selectedAccounts.map(sa => {
        return (<AccountCard account={sa} key={sa.accountID} cancel={cancelAccount} options={accountCardOptions} />);
    });

    return (
        <div id="singleLetters">
            <div className="division-list">
                <InputGroup>
                    <InputGroupAddon addonType="prepend">
                        <InputGroupText><FontAwesomeIcon icon={faUsers} /></InputGroupText>
                    </InputGroupAddon>
                    <Input type="select" value={divisionId} onChange={e => setDivisionId(+e.target.value)}>
                        <option value={0}>Environmental Fees</option>
                        {divisions.filter(d => ![1, 2, 3].includes(d.divisionID)).map(d => (<option key={d.divisionID} value={d.divisionID}>{d.divisionName}</option>))}
                    </Input>
                </InputGroup>
            </div>
            <div className="template-selector">
                <Input type="file" ref={templateFileEl} onChange={updateFile} />
            </div>
            <div className="select-btn">
                <Button color="danr-green" className="btn-block" onClick={toggleAccountSelectModal}><span>Select Accounts</span></Button>
            </div>
            <div className="account-list">
                {selectedAccountsJSX}
            </div>
            <div className="actions">
                <Button onClick={sendTestEmail} disabled={isSendingEmails || templateFile === null || selectedAccounts.length === 0}>Test Letter</Button>
                <Button onClick={toggleLetterConfirmationModal} color="danr-green" disabled={isSendingEmails || templateFile === null || selectedAccounts.length === 0}>Send Letters</Button>
            </div>
            {isSendingEmails ? (<div className="loading"><img src={LoadingSVG} alt="Loading..." /></div>) : null}
            <AccountSelect multiple={true} open={accountSelectModal} toggle={toggleAccountSelectModal} select={selectAccounts} accountCardOptions={accountSelectOptions} searchOptions={{ hasUnpaidFees: true }} />
            <LetterConfirmationModal open={letterConfirmationModal} toggle={toggleLetterConfirmationModal} accept={acceptLetterConfirmationModal} decline={declineLetterConfirmationModal} />
            <LettersSuccessModal open={lettersSuccessModal} toggle={toggleLettersSuccessModal} />
        </div>
    );
}

export default AccountLetters;